<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold m-1 pb-2 mx-2">
                {{ trans.side_bar_navi.gallery }}
            </div>
        </div>
        <div class="overflow-y-auto h-screen pb-20">
            <div class="mx-4">
                <div class="my-3 pb-48 mb-96 sm:mb-20">
                    <!-- SmartHash出力部分 -->
                    <div class="smarthash">
                        <ul></ul>
                    </div>
                    <a href="javascript:void(0);" class="smarthash_more_btn"
                        >もっと見る</a
                    >
                    <div class="smarthash__zoom">
                        <span class="smarthash__zoom-overlay"></span>
                    </div>
                    <!-- /SmartHash出力部分 -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        trans: {
            type: Object,
            required: true,
        },
    },
};
</script>
